/* eslint-disable @gitlab/require-i18n-strings */ import { GlModal, GlButton } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __, s__ } from '~/locale';
import SimpleCopyButton from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/simple_copy_button.vue?vue3';
import { getBaseURL } from '~/lib/utils/url_utility';
export const i18n = {
    modalTitle: s__('ForksDivergence|Resolve merge conflicts manually'),
    modalMessage: s__('ForksDivergence|The upstream changes could not be synchronized to this project due to file conflicts in the default branch. You must resolve the conflicts manually:'),
    step1: __('Step 1.'),
    step2: __('Step 2.'),
    step3: __('Step 3.'),
    step4: __('Step 4.'),
    step1Text: s__("ForksDivergence|Fetch the latest changes from the upstream repository's default branch:"),
    step2Text: s__("ForksDivergence|Check out to a branch, and merge the changes from the upstream project's default branch. You likely need to resolve conflicts during this step."),
    step3Text: s__('ForksDivergence|Push the updates to remote:'),
    copyToClipboard: __('Copy to clipboard'),
    close: __('Close')
};
export default {
    name: 'ForkSyncConflictsModal',
    components: {
        GlModal,
        GlButton,
        SimpleCopyButton
    },
    props: {
        sourceDefaultBranch: {
            type: String,
            required: false,
            default: ''
        },
        sourcePath: {
            type: String,
            required: false,
            default: ''
        },
        selectedBranch: {
            type: String,
            required: true
        }
    },
    computed: {
        instructionsStep1 () {
            const baseUrl = getBaseURL();
            return `git fetch ${baseUrl}${this.sourcePath} ${this.sourceDefaultBranch}`;
        },
        instructionsStep2 () {
            return `git checkout ${this.selectedBranch}\ngit merge FETCH_HEAD`;
        }
    },
    methods: {
        // eslint-disable-next-line vue/no-unused-properties -- invoked externally via this.$refs.modal.show() in fork_info.vue
        show () {
            this.$refs.modal.show();
        },
        hide () {
            this.$refs.modal.hide();
        }
    },
    i18n,
    instructionsStep3: 'git push'
};
